var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpleCell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.8376 1.58931H13.1607C6.76903 1.58931 1.58759 6.77075 1.58759 13.1624V72.8393C1.58759 79.2309 6.76903 84.4124 13.1607 84.4124H72.8376C79.2292 84.4124 84.4106 79.2309 84.4106 72.8393V13.1624C84.4106 6.77075 79.2292 1.58931 72.8376 1.58931Z",
    fill: "url(#paint0_linear_39_7384)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8376 1.58933C79.2305 1.58933 84.4107 6.77117 84.4107 13.1624V72.8376C84.4107 79.2288 79.2288 84.4107 72.8376 84.4107H13.1624C6.76948 84.4107 1.58933 79.2288 1.58933 72.8376V13.1624C1.58933 6.77117 6.77117 1.58933 13.1624 1.58933H72.8376ZM72.8376 0H13.1624C5.90442 0 0 5.90442 0 13.1624V72.8376C0 80.0956 5.90442 86 13.1624 86H72.8376C80.0956 86 86 80.0956 86 72.8376V13.1624C86 5.90442 80.0956 0 72.8376 0Z",
    fill: "#1A1151"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39_7384",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 84,
    height: 84
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8376 1.58931H13.1607C6.76903 1.58931 1.58759 6.77075 1.58759 13.1624V72.8393C1.58759 79.2309 6.76903 84.4124 13.1607 84.4124H72.8376C79.2292 84.4124 84.4106 79.2309 84.4106 72.8393V13.1624C84.4106 6.77075 79.2292 1.58931 72.8376 1.58931Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39_7384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 12.1837C60.47 12.1837 74.6322 6.43503 74.6322 -0.65638C74.6322 -7.74779 60.47 -13.4965 43 -13.4965C25.5301 -13.4965 11.3679 -7.74779 11.3679 -0.65638C11.3679 6.43503 25.5301 12.1837 43 12.1837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 97.2526C60.47 97.2526 74.6322 91.5038 74.6322 84.4124C74.6322 77.321 60.47 71.5723 43 71.5723C25.5301 71.5723 11.3679 77.321 11.3679 84.4124C11.3679 91.5038 25.5301 97.2526 43 97.2526Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2031 26.3588C100.57 33.0655 97.9174 42.5471 90.5526 44.6216C84.0274 46.4586 77.2104 41.521 74.5626 36.0117C72.4662 31.6492 73.2752 27.5291 73.5212 26.3588C74.6678 20.9276 79.2746 13.5017 86.3613 13.5186C93.5396 13.5356 98.087 20.8869 99.2014 26.3588H99.2031Z",
    fill: "#4C4C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79471 40.4524C2.31358 42.6557 -7.42762 41.2225 -10.4146 34.1799C-13.0623 27.9396 -9.02542 20.5527 -3.89446 17.2299C0.167904 14.5991 4.35748 14.8807 5.5499 14.9774C11.0812 15.4286 19.0312 19.0584 19.9098 26.0908C20.8003 33.2131 14.0817 38.6527 8.7964 40.4507L8.79471 40.4524Z",
    fill: "#4C4C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3516 54.0677C102.105 58.1623 101.99 66.6602 97.9344 71.0651C92.0198 77.492 78.3044 74.5712 71.9013 66.9655C65.2964 59.1206 66.253 46.0413 70.4663 44.0059C73.0632 42.7507 75.1071 46.5603 84.4124 49.7458C92.7729 52.6089 95.6021 51.0671 98.3516 54.0677Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5361 47.0488C21.3194 49.873 23.6822 58.0384 21.0836 63.4323C17.2943 71.3026 3.32454 72.4984 -5.0156 67.0859C-13.6187 61.5037 -16.509 48.7111 -13.0708 45.5392C-10.9506 43.5835 -7.88725 46.6316 1.94215 46.9725C10.7742 47.2778 13.0335 44.9812 16.5361 47.0488Z",
    fill: "black"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7149 9.83617H16.285C12.7224 9.83617 9.83441 12.7242 9.83441 16.2868V69.7166C9.83441 73.2792 12.7224 76.1672 16.285 76.1672H69.7149C73.2774 76.1672 76.1655 73.2792 76.1655 69.7166V16.2868C76.1655 12.7242 73.2774 9.83617 69.7149 9.83617Z",
    fill: "url(#paint1_linear_39_7384)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.9999 49.415C30.0038 49.415 18.2628 45.473 9.83441 39.1293V69.7149C9.83441 73.2769 12.723 76.1655 16.285 76.1655H69.7132C73.2752 76.1655 76.1637 73.2769 76.1637 69.7149V39.1293C67.7354 45.473 55.9944 49.415 42.9982 49.415H42.9999Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2591 11.7088C74.8154 12.662 75.1411 13.7696 75.1411 14.9536V68.3817C75.1411 71.9437 72.2525 74.8323 68.6905 74.8323H15.2606C13.4881 74.8323 11.8818 74.1165 10.7166 72.958C11.8343 74.873 13.9071 76.1638 16.2851 76.1638H69.7133C73.2753 76.1638 76.1639 73.2752 76.1639 69.7132V16.2851C76.1639 14.4956 75.4345 12.8757 74.2574 11.7071L74.2591 11.7088Z",
    fill: "url(#paint2_linear_39_7384)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_39_7384",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 68,
    height: 68
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7149 9.83617H16.285C12.7224 9.83617 9.83441 12.7242 9.83441 16.2868V69.7166C9.83441 73.2792 12.7224 76.1672 16.285 76.1672H69.7149C73.2774 76.1672 76.1655 73.2792 76.1655 69.7166V16.2868C76.1655 12.7242 73.2774 9.83617 69.7149 9.83617Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_39_7384)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M93.4314 11.9832C94.1919 -5.0914 75.1075 -19.8105 50.8054 -20.8928C26.5032 -21.9751 6.18599 -9.01077 5.42557 8.06381C4.66515 25.1384 23.7495 39.8575 48.0516 40.9398C72.3538 42.0221 92.671 29.0578 93.4314 11.9832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9551 -2.3728C83.7155 -19.4474 64.6311 -34.1664 40.329 -35.2487C16.0268 -36.331 -4.29039 -23.3667 -5.05081 -6.29217C-5.81123 10.7824 13.2731 25.5015 37.5753 26.5838C61.8774 27.6661 82.1946 14.7018 82.9551 -2.3728Z",
    fill: "white"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M69.7149 9.83617H16.285C12.723 9.83617 9.83441 12.7248 9.83441 16.2868V17.8235C9.83441 14.2615 12.723 11.3729 16.285 11.3729H69.7132C73.2752 11.3729 76.1637 14.2615 76.1637 17.8235V16.2868C76.1637 12.7248 73.2752 9.83617 69.7132 9.83617H69.7149Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M72.9289 16.1383C73.2556 14.7543 72.3984 13.3675 71.0144 13.0408C69.6304 12.7142 68.2437 13.5713 67.917 14.9553C67.5904 16.3393 68.4475 17.7261 69.8315 18.0528C71.2155 18.3794 72.6023 17.5223 72.9289 16.1383Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M65.6665 15.1747C66.1692 14.672 66.1692 13.8568 65.6665 13.3541C65.1637 12.8513 64.3486 12.8513 63.8458 13.3541C63.3431 13.8568 63.3431 14.672 63.8458 15.1747C64.3486 15.6775 65.1637 15.6775 65.6665 15.1747Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M14.1903 16.4682C14.9013 16.4682 15.4777 15.8919 15.4777 15.1808C15.4777 14.4698 14.9013 13.8934 14.1903 13.8934C13.4793 13.8934 12.9029 14.4698 12.9029 15.1808C12.9029 15.8919 13.4793 16.4682 14.1903 16.4682Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3101 70.8463C72.9256 70.8463 73.4245 70.3474 73.4245 69.7319C73.4245 69.1164 72.9256 68.6175 72.3101 68.6175C71.6947 68.6175 71.1957 69.1164 71.1957 69.7319C71.1957 70.3474 71.6947 70.8463 72.3101 70.8463Z",
    fill: "#E1C2FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9983 72.478C69.9983 72.9428 69.6217 73.321 69.1553 73.321C68.6888 73.321 68.3123 72.9445 68.3123 72.478C68.3123 72.0116 68.6888 71.635 69.1553 71.635C69.6217 71.635 69.9983 72.0116 69.9983 72.478Z",
    fill: "#E1C2FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M72.8376 1.58931H13.1624C6.77114 1.58931 1.58929 6.77116 1.58929 13.1624V14.3412C1.58929 7.94831 6.77114 2.76816 13.1624 2.76816H72.8376C79.2305 2.76816 84.4123 7.95001 84.4123 14.3412V13.1624C84.4123 6.76946 79.2305 1.58931 72.8376 1.58931Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.8376 83.0792H13.1624C6.77114 83.0792 1.58929 77.8973 1.58929 71.5061V72.8393C1.58929 79.2305 6.77114 84.4124 13.1624 84.4124H72.8376C79.2305 84.4124 84.4123 79.2305 84.4123 72.8393V71.5061C84.4123 77.899 79.2305 83.0792 72.8376 83.0792Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_7384",
    x1: 43,
    y1: 84.4124,
    x2: 43,
    y2: 1.58931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#3B1E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5F27AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7C2FB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9134BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9D37C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A239C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_39_7384",
    x1: 42.9999,
    y1: 76.1655,
    x2: 42.9999,
    y2: 9.83617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#832DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AE39D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4FD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_39_7384",
    x1: 26.7845,
    y1: 89.3296,
    x2: 89.3314,
    y2: 26.7828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC98FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EC98FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC98FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleCell);
export default __webpack_public_path__ + "static/media/purple-cell.9e87d84ccc9deca42f0033d85776eb07.svg";
export { ForwardRef as ReactComponent };